module.exports = __webpack_public_path__ + "img/work_stopped.978d5c5d.svg";